export enum StreamingPlatform  {
    SPOTIFY = "Spotify",
    APPLE = "Apple"
}
